import * as React from 'react'
import { JsonInput } from './JsonInput'

type PermissionsProps = {
  permissions: string[] | null | string
}

const inputProps = {
  readOnly: true,
}

export const Permissions: React.FunctionComponent<PermissionsProps> = ({
  permissions,
  ...rest
}) => {
  const safePermissions =
    permissions === null
      ? []
      : Array.isArray(permissions)
      ? permissions
      : [permissions]

  return (
    <JsonInput
      json={safePermissions}
      label="Permissions"
      rows={5}
      inputProps={inputProps}
      {...rest}
    />
  )
}
